import Vue from 'vue'
import VueRouter from 'vue-router'
import Base from '@/views/Base.vue'
import ItemList from '../views/ItemList.vue'
import Item from '../views/Item.vue'
import UserConf from '../views/UserConf.vue'
import Login from '../views/Login.vue'

// store
import store from '@/store/index.js'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/',
    name: 'Base',
    component: Base,
    children: [
      {
        path: '',
        name: 'ItemList',
        component: ItemList
      },
      {
        path: '/userconf',
        name: 'UserConf',
        component: UserConf
      },
      {
        path: '/itemlist',
        name: 'ItemList',
        component: ItemList
      },
      {
        path: '/item/:id',
        name: 'Item',
        component: Item
      },
      {
        path: '/newitem',
        name: 'NewItem',
        component: Item
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (store.state.username !== null) {
    store.dispatch('check').then(() => {
      if (store.state.username !== null) {
        if (to.path === '/login') {
          next('/')
        } else {
          next()
        }
      } else {
        next('/login')
      }
    }).catch(() => {
      next('/login')
    })
  } else if (to.path === '/login') {
    next()
  } else {
    next('/login')
  }
})

export default router
